import React from 'react'

export const puertoRicoSetupVars = {
  siteId: 'puerto_rico',
  pathPrefix: '/pr',
  menuHeader: "Discover Puerto Rico's Solution for:",
  appUrl: 'https://pr.headed2.com',
  logoImg: '/images/assets/puerto_rico/horizontal/dark.svg',
  headerTitle: `The PuertoRico CareerExplorer is a system designed for Puerto Rico`
}
